import React from "react";
import { Box, FlexBox } from "../../primitives";
import { IconNameText, WrapperIcon } from "./header.styled";
import { MdOutlineDeselect, MdSelectAll } from "react-icons/md";
import { CardSelected } from "../../../type";

interface SelectDeselectCardsProps {
  setCardsClicked: (arg1: string[]) => void;
  cardsBoardFiltered: CardSelected[];
  cardsClicked: string[];
}

export const SelectDeselectCards = ({
  setCardsClicked,
  cardsBoardFiltered,
  cardsClicked,
}: SelectDeselectCardsProps) => {
  const isCardsBoardFull = cardsBoardFiltered?.length;
  const hasCardsClicked = cardsClicked?.length;

  const handleSelectAll = () => {
    if (!isCardsBoardFull) return;

    const filteredIds = cardsBoardFiltered.map((card) => card.uid.toString());
    const merged = [...cardsClicked, ...filteredIds];
    setCardsClicked(merged);
  };

  const handleDeselectAll = () => {
    if (!hasCardsClicked) return;
    const filteredIds = new Set(
      cardsBoardFiltered.map((card) => card.uid.toString())
    );
    const updated = cardsClicked.filter((uid) => !filteredIds.has(uid));
    setCardsClicked(updated);
  };

  return (
    <FlexBox css={{ alignItems: "center", gap: 20 }}>
      <WrapperIcon>
        <Box
          onClick={() => {
            handleSelectAll();
          }}
          css={{ cursor: isCardsBoardFull ? "pointer" : "not-allowed" }}
        >
          <MdSelectAll size={20} color={isCardsBoardFull ? "green" : "grey"} />
        </Box>
        <IconNameText>Select All</IconNameText>
      </WrapperIcon>
      <WrapperIcon>
        <Box
          onClick={() => {
            handleDeselectAll();
          }}
          css={{ cursor: hasCardsClicked ? "pointer" : "not-allowed" }}
        >
          <MdOutlineDeselect
            size={20}
            color={hasCardsClicked ? "green" : "grey"}
          />
        </Box>
        <IconNameText>Deselect All</IconNameText>
      </WrapperIcon>
    </FlexBox>
  );
};
